import {
  publicJobOpeningContact,
  publicJobOtherContacts,
} from "../../data/jobOpeningPublic";

export function JobContactSections({ job, titleStyle, compact = false }) {
  const contact = publicJobOpeningContact(job);
  const others = publicJobOtherContacts(job);
  if (!contact && others.length === 0) return null;

  return (
    <div>
      {contact ? (
        <div>
          <h2 style={titleStyle}>Kontakt</h2>
          <JobContactCard contact={contact} />
        </div>
      ) : null}
      {others.length > 0 ? (
        <div style={{ marginTop: contact ? (compact ? 16 : 20) : 0 }}>
          <h2 style={titleStyle}>Andre kontakter</h2>
          {others.map((person, index) => (
            <JobContactCard
              key={`${person.email || person.name || "other"}-${index}`}
              contact={person}
              style={{ marginTop: index === 0 ? 0 : 12 }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

function JobContactCard({ contact, style }) {
  return (
    <div style={style}>
      {contact.name ? (
        <div style={{ fontWeight: 700, color: "var(--ink)" }}>{contact.name}</div>
      ) : null}
      {contact.email ? (
        <a
          href={`mailto:${contact.email}`}
          style={{
            color: "var(--airon-3)",
            display: "block",
            marginTop: 4,
          }}
        >
          {contact.email}
        </a>
      ) : null}
      {contact.phone ? (
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "var(--ink-2)",
            display: "block",
            marginTop: 4,
          }}
        >
          {contact.phone}
        </a>
      ) : null}
    </div>
  );
}
